import { WecomConversationStatusChangeData } from "../../handler/wecom/ws-types";
import EventBus from "../event-bus";
const conversationStatusChangeHook =
  new EventBus<WecomConversationStatusChangeData>(
    "conversationStatusChangeHook"
  );

export default conversationStatusChangeHook;
